module.exports = __webpack_public_path__ + "media/images/trophy-notice-a1398b455de91ea42e7ead26776bfa11.svg";